import camelcaseKeys from 'camelcase-keys-recursive';
import type { CamelCasedPropertiesDeep } from 'type-fest';

const camelCaseKeysDeep = <T>(args: T) => camelcaseKeys(args) as CamelCasedPropertiesDeep<T>;

export default camelCaseKeysDeep;
